import { createFileRoute } from '@tanstack/react-router'
import { useEffect, useRef } from 'react'
import { z } from 'zod'
import { useCustomerLogout } from '@/entities/customer-session'
import { Card } from '@/shared/ui/card'
import { Spinner } from '@/shared/ui/spinner'

// Разлогин заказчика: POST /auth/customer/logout гасит цепочку refresh и
// сбрасывает cookie, дальше — на единый вход с пометкой «вы вышли».
const LogoutSearchSchema = z.object({
  rd: z.string().optional(),
})

export const Route = createFileRoute('/_public/customer/logout')({
  validateSearch: (search: Record<string, unknown>) => LogoutSearchSchema.parse(search),
  component: CustomerLogoutPage,
})

function CustomerLogoutPage() {
  const { rd } = Route.useSearch()
  const navigate = Route.useNavigate()
  const { mutateAsync } = useCustomerLogout()
  // StrictMode проигрывает эффекты дважды — второй POST здесь лишний.
  const started = useRef(false)

  // Ведём переход промисом, а не состоянием мутации и не её колбэками: запрос
  // стартует на маунте, и рендер-состояние наблюдателя до экрана может уже не
  // дойти — экран «выходим» залипал бы навсегда. Исход не важен: cookie гасит
  // сервер, локальный кэш — мутация, а держать пользователя здесь нельзя даже
  // при сетевом сбое.
  useEffect(() => {
    if (started.current) return
    started.current = true
    void mutateAsync()
      .catch(() => undefined)
      .finally(() => {
        void navigate({
          to: '/login',
          search: { ...(rd ? { rd } : {}), notice: 'signedout' },
          replace: true,
        })
      })
  }, [mutateAsync, navigate, rd])

  return (
    <Card>
      <div className="flex flex-col items-center gap-4 text-center">
        <Spinner label="Выходим" />
        <p className="text-sm text-text-secondary">Выходим из аккаунта…</p>
      </div>
    </Card>
  )
}
